import React from 'react'
import PaginationContainer from '../../../Components/BonusUi/Pagination'

export default function Pagination() {
  return (
    <div className='page-body'>
        <PaginationContainer/>
    </div>
  )
}
